module.exports = __webpack_public_path__ + "static/media/l4.adb50d96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/list/l4.jpg
// module id = 284
// module chunks = 0